import { React } from "react"
import SidebarDashboardSupervisor from "../Homepage/sidebars/SidebarDashboardSupervisor"
export default function DataDictionaries() {
  return (
    <div className="layout-with-sidebar">
      <SidebarDashboardSupervisor />
      <div className="my-dashboard-wrapper">
        <h1>Data Dictionaries</h1>
      </div>
    </div>
  )
}
